import type { ConversationMessage } from '../../store/converse/types';

export const getTotalHelpDesks = (message: ConversationMessage): number => {
    return message?.appendices?.filter((appendix) => appendix.type === 'helpDesk')?.length ?? 0;
};
